import React, { ReactNode } from 'react';
import styles from './Header.module.css';
import { Row } from 'react-bootstrap';
import classnames from 'classnames';
import { FloComponentProps } from 'components';

interface HeaderProps extends FloComponentProps {
  children: ReactNode;
  noBackground?: boolean;
}

export const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  return (
    <Row className={classnames(
        styles.root,
        props.className,
        { [styles.background]: !props.noBackground }
      )}>
      {props.children}
    </Row>
  );
};

export default Header;